

export const data = [
    {
        title: "Передача полномочий руководителя",
        description:
            "Передача права согласования заявлений работников в ЛК/ЭП на установленный срок",
        // icon: blankList,
        path: "/divisions/structure/delegation/transfer",
    },
    {

        // title: "Изменение конечной даты замещения",
        title: "Прекращение замещения",

        description:
            "Сокращение или досрочное прекращение передачи права согласования заявлений работников в ЛК/ЭП",
        // icon: blankList,
        // path: "/divisions/structure/delegation/revoke",
        path: "/divisions/structure/delegation/revoke",
    },
];
